import React from 'react'

function DSTAccess() {
  return (
    <div className="Grid Grid--withGutter u-marginBottom10gu">
      <div className="u-before2of12 u-size4of12">
        <h3 className="u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0 u-paddingBottom1gu u-marginBottom1gu">
          DST Vision Access
        </h3>
        <p className="u-marginBottom2gu">
          View your clients&apos; mutual fund and 529 plan account information.
        </p>
        <a
          href="https://vision.ssnc.cloud/tf/Vision"
          target="_blank"
          className="Button Button--secondary u-block"
          rel="noreferrer"
        >
          Log in to DST
        </a>
      </div>
    </div>
  )
}

export default DSTAccess
